module.exports = __webpack_public_path__ + "img/ico-personal-email-address.c4b3d3ec.svg";